<template>
  <div>
    <section class="top_registration" v-if="isRegistrationEnabled">
      <p><router-link :to="{ name: 'UserRegistration' }" class="btn arrow">会員登録</router-link></p>
      <p>
        初めてのご利用の際は、上記【会員登録】よりお進みください。<br>
        ※当番組からの配信と<router-link :to="{ name: 'PageFixed', params: { code: 'terms_of_service' } }" class="link_main--text">利用規約</router-link>に同意をお願いします。
      </p>
    </section>
    <section class="top_registration" v-else>
      <p>会員数増大に伴い、現在一時的に新規会員登録を制限しています。<br>既に当番組会員のお客様でお問い合せの際は、下部「お問い合せ」をタップしメールにてご連絡くださいませ。</p>
    </section>
    <section class="top_free_fortune text_center">
      <h2 class="header_underline">無料占い</h2>
      <p>一日一回本日の運気を無料で占えます。</p>
      <p><img src="/assets/img/banner_astrology.png" alt="12星座占い"></p>
    </section>
    <section class="top_overview text_center" v-if="info != null">
      <h2 class="header_underline">当番組について</h2>
      <p class="text_left">
        『{{ info.title }}』では、全ての会員様が望む幸せ・未来等、明るく満足に過ごせる毎日のために、
        厳正な採用テストで選ばれた第一線で活躍中のプロ鑑定師、
        そして所属スタッフ一同が誠心誠意お手伝いさせて頂きます。
      </p>
      <p><router-link :to="{ name: 'UserLogin' }" class="btn arrow">ログイン</router-link></p>
      <p><router-link :to="{ name: 'PageFixed', params: { code: 'about_points' } }" class="arrow link_main--text">料金表を見る</router-link></p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'TopNotLoggedIn',
  data () {
    return {
      info: this.$store.getters.siteInfo || null,
      isRegistrationEnabled: true
    }
  },
  computed: {
    siteInfo () {
      return this.$store.getters.siteInfo
    }
  },
  watch: {
    siteInfo (val, old) {
      this.info = val
    }
  }
}
</script>
